import { render, staticRenderFns } from "./IndagineEpidemiologicaTetanoViewComponent.vue?vue&type=template&id=29d45ce6"
import script from "./IndagineEpidemiologicaTetanoViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaTetanoViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports